const MODULE_NAME = "SYSTEM_COUNT";
const SYSTEM_COUNT_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const SYSTEM_COUNT_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  SYSTEM_COUNT_FETCH_STARTED,
  SYSTEM_COUNT_FETCH_COMPLETED
};
